import * as React from "react";

export default () => {
  return (
    <div>Annonsbeskrivning. Kan redigeras individuellt på nästa steg.</div>
  );
};
